import React from 'react';

const Landing = () => {
  return (
    <div className="landing-section" id="top">
      <img
        className="logo-big"
        src="resources/img/logo.png"
        alt="Michal Codes Logo"
      />
    </div>
  );
};

export default Landing;
